import { Box, Grid, Typography } from '@mui/material';
import logo from 'assets/logo.png';
import { isPortalGuideVideosVisible } from 'utils/portalGuideUi';

export const GetStarted = () => {
  const showVideos = isPortalGuideVideosVisible();

  return (
    <Box padding="48px">
      <Grid container justifyContent="center" padding="25px">
        <img src={logo} style={{ width: '300px' }} alt="Leap Easy logo" />
      </Grid>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={8}>
          <Typography variant="h4" textAlign="center">
            Welcome to the LEAP Portal User Guide
          </Typography>
          <Typography textAlign="center" component="div" sx={{ mt: 2 }}>
            <Typography variant="body1" paragraph>
              The Leap Portal helps Admins, Operator, Full Portfolio, Multi-Site, and Property
              Manager users work with Leap Insurance and application data in one place. Use it to
              file and track insurance claims, review invoices, manage users and delegations, and
              understand the financial impact of Leap across your portfolio.
            </Typography>
            <Typography variant="body1" paragraph>
              {showVideos ? (
                <>
                  This guide walks through the redesigned navigation, key pages, role permissions,
                  and featured training videos. Use the <strong>Documentation</strong> tab for
                  page-by-page instructions and the <strong>Featured videos</strong> tab for
                  step-by-step walkthroughs.
                </>
              ) : (
                <>
                  This guide walks through the redesigned navigation, key pages, and role
                  permissions. Use the <strong>Documentation</strong> tab for page-by-page
                  instructions.
                </>
              )}
            </Typography>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};
